/* eslint-disable camelcase */
// Reference payloads from Chase's "Autos Traceability Metadata Payload" doc.
// These are the same JSON examples designers mock against and the contract
// editor seeds new scenarios from. Keep them in lockstep with the source doc.

import { MessageDetails } from './types';

export const PRESET_A_FULLY_POPULATED: MessageDetails = {
  display_name: 'Welcome Offer Nudge',
  description:
    'Re-introduces the welcome offer to recently opted-in subscribers.',
  parent_id: 'welcome_series_v3',
  full_reference_text:
    "Welcome to Alpine Gear! Here's 20% off your first order with code SAVE20.",
  customer_states: ['prospective_customer'],
  lifecycle_stages: ['acquisition', 'interest'],
  message_type: 'conversion',
  group: 'offer',
  urgency: 'light',
  focus: 'blended',
  levers: ['offer', 'personalization'],
  is_conversational: true,
  references_previous_offer: false,
  offers_new_discount: true,
  price_increase: false,
  scarcity: false,
  timing_pressure: true,
  competition: false,
  runtime_context: {
    offer: {
      title: '10% Off Spring Sale',
      discount_value: '10%',
      discount_code: 'SPRING10',
    },
    products: [
      { id: '1', title: 'Product One', handle: 'product-one', image_url: null },
      { id: '2', title: 'Product Two', handle: 'product-two', image_url: null },
    ],
    content: [{ url: 'https://faq.example.com', destination: 'HOMEPAGE_LINK' }],
    tone_of_voice: {
      casual_formal: 4,
      gentle_bold: 2,
      product_lifestyle: 5,
      concise_chatty: 3,
      relaxed_urgent: 5,
    },
  },
  verified: true,
};

// Designers should mock this state to confirm the UI degrades gracefully when
// nearly every classification is unset.
export const PRESET_B_MINIMAL: MessageDetails = {
  display_name: 'General Follow-up',
  description: 'Generic follow-up tactic with no targeting.',
  parent_id: null,
  full_reference_text: null,
  customer_states: [],
  lifecycle_stages: [],
  message_type: null,
  group: null,
  urgency: null,
  focus: null,
  levers: [],
  is_conversational: null,
  references_previous_offer: null,
  offers_new_discount: null,
  price_increase: null,
  scarcity: null,
  timing_pressure: null,
  competition: null,
  runtime_context: null,
  verified: null,
};

export const PRESET_C_HEAVY_URGENCY: MessageDetails = {
  display_name: 'Cart Recovery (Urgency)',
  description: 'Urgent reminder that an item in cart is selling out.',
  parent_id: 'abandoned_checkout_v2',
  full_reference_text: null,
  customer_states: ['one_time_purchaser', 'repeat_customer'],
  lifecycle_stages: ['conversion'],
  message_type: 'conversion',
  group: 'nudge',
  urgency: 'heavy',
  focus: 'product',
  levers: ['scarcity', 'social_proof'],
  is_conversational: false,
  references_previous_offer: true,
  offers_new_discount: false,
  price_increase: true,
  scarcity: true,
  timing_pressure: true,
  competition: false,
  runtime_context: null,
  verified: null,
};

export const MESSAGE_DETAILS_PRESETS = {
  A: PRESET_A_FULLY_POPULATED,
  B: PRESET_B_MINIMAL,
  C: PRESET_C_HEAVY_URGENCY,
} as const;

export type MessageDetailsPresetId = keyof typeof MESSAGE_DETAILS_PRESETS;

export const MESSAGE_DETAILS_PRESET_LABELS: Record<
  MessageDetailsPresetId,
  string
> = {
  A: 'Sample A · Fully populated',
  B: 'Sample B · Minimal',
  C: 'Sample C · Heavy urgency',
};
